/**
 * Storefront API GraphQL queries
 * Product and variant data queries for prices, availability, and details
 */

import { gql } from '@apollo/client/core'
import { PRODUCT_VARIANT_FRAGMENT } from './fragments'

export const GET_PRODUCT_BY_HANDLE = gql`
  query GetProductByHandle($handle: String) {
    product(handle: $handle) {
      id
      featuredImage {
        src
      }
      images(first: 2) {
        edges {
          node {
            altText
            url
          }
        }
      }
      options(first: 10) {
        name
      }
      tags
      variants(first: 50) {
        nodes {
          ...ProductVariantFragment
        }
      }
    }
  }

  ${PRODUCT_VARIANT_FRAGMENT}
`

export const GET_INVENTORY_BY_HANDLE = gql`
  query GetInventoryByHandle($handle: String!) {
    product(handle: $handle) {
      id
      handle
      totalInventory
    }
  }
`

export const QUERY_SEARCH_PRODUCTS = gql`
  query QuerySearchProducts($first: Int!, $value: String, $key: String = "stylecode", $namepsace: String = "related_products") {
    search(first: $first, query: "", productFilters: [{ productMetafield: { value: $value, key: $key, namespace: $namespace } }], unavailableProducts: SHOW) {
      edges {
        node {
          ... on Product {
            metafields(
              identifiers: [
                { key: "swatch_image", namespace: $namespace }
                { key: "swatch_hex", namespace: $namespace }
                { key: "swatch_label", namespace: $namespace }
              ]
            ) {
              value
              key
            }
            handle
            variants(first: 1) {
              nodes {
                ...ProductVariantFragment
              }
            }
          }
        }
      }
    }
  }

  ${PRODUCT_VARIANT_FRAGMENT}
`

export const QUERY_VARIANT_PRICES = gql`
query variantPrices($country: CountryCode, $ids: [ID!]!) @inContext(country: $country) {
  nodes(ids: $ids) {
    ... on ProductVariant {
      id
      price {
        amount
        currencyCode #active local currency
      }
      compareAtPrice {
        amount
        currencyCode
      }
    }
  }
}
`
